/**
 * Lux Header Enhancement Layer
 * - Measures header height live → --lux-header-height (lets the hero
 *   sit underneath the transparent header with zero layout guesswork).
 * - Toggles body.lux-header-at-top based on scroll position.
 * - Forces a solid header whenever any header drawer/search/menu
 *   <details> opens (readability over imagery).
 * Sticky hide/reveal behavior itself is Dawn-native — no JS here for it.
 */
(function () {
  'use strict';

  var body = document.body;
  var rafPending = false;
  var TOP_THRESHOLD = 24; // px scrolled before header turns solid

  function headerEl() {
    return document.querySelector('.section-header .header-wrapper');
  }

  /* ---------- 1. Live header height → CSS variable ---------- */

  function setHeaderHeight() {
    var el = headerEl();
    if (!el) return;
    document.documentElement.style.setProperty(
      '--lux-header-height',
      el.offsetHeight + 'px'
    );
  }

  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(setHeaderHeight);
    var target = headerEl();
    if (target) ro.observe(target);
  } else {
    window.addEventListener('resize', setHeaderHeight);
  }
  setHeaderHeight();

  /* ---------- 2. Transparent state machine (opt-in) ---------- */

  if (body.hasAttribute('data-lux-transparent-header')) {

  function updateScrollState() {
    body.classList.toggle(
      'lux-header-at-top',
      (window.scrollY || window.pageYOffset) < TOP_THRESHOLD
    );
    rafPending = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!rafPending) {
        rafPending = true;
        window.requestAnimationFrame(updateScrollState);
      }
    },
    { passive: true }
  );

  updateScrollState();

  } // end transparent state machine

  /* ---------- 3. Solid header while any header panel is open ---------- */

  function updateForcedSolid() {
    var section = document.querySelector('.section-header');
    if (!section) return;
    var anyOpen = section.querySelector('details[open]') !== null;
    body.classList.toggle('lux-header-forced-solid', anyOpen);
  }

  // 'toggle' doesn't bubble, but capture phase still reaches it.
  document.addEventListener('toggle', updateForcedSolid, true);

  // Re-sync after Theme Editor reloads the header section.
  document.addEventListener('shopify:section:load', function () {
    setHeaderHeight();
    updateForcedSolid();
    updateScrollState();
  });
})();